module.exports = __webpack_public_path__ + "img/right-arrow.6aa55262.svg";